import React, { useContext, useEffect, useRef, useState } from 'react'
import SideBar from '../../components/SideBar/SideBar'
import NavBar from '../../components/NavBar/NavBar'
import { createPrompt, deletePromptByID, getAllPrompts, getAllPromptsWithoutPagination, updatePrompt } from '../../services/promptService';
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import './BastionGPTScreen.css'
import { formatText } from '../../utils/formatText';
import PromptBar from './PromptBar';
import UserPrompt from './UserPrompt';
import LeftPanel from './LeftPanel';
import { updateConversation } from '../../services/conversation';
import axios from 'axios';
import { getAuthHeader } from '../../utils/authTools';
import { axiosInstance } from '../../utils/axios';
import AIimage from "../../assets/image001.png";
import AuthContext from '../../store/AuthContext';
import Tooltip from '../../components/ToolTip/ToolTip';

function BastionGPTScreen() {
    const location = useLocation();
    const receivedData = location.state;

    const [creativity, setCreativity] = useState(0.5);
    const [rightPanel, setRightPanel] = useState(true);
    const [loading, setLoading] = useState(false);
    const [prompts, setPrompts] = useState([])
    const [inputValue, setInputValue] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const textAreaRef = useRef(null)
    const [selectedPrompt, setSelectedPrompt] = useState(null)
    const [editModalVisible, setEditModalVisible] = useState(false)
    const [promptSearch, setPromptSearch] = useState("")
    const navigate = useNavigate();
    const [historyArray, setHistoryArray] = useState([]);
    const [summaryLoading, setSummaryLoading] = useState(false);
    const [isNewPrompt, setIsNewPrompt] = useState(false);
    const [isCopied, setIsCopied] = useState(false);
    const [isChatSelected, setIsChatSelected] = useState(null)
    const [chats, setChats] = useState([]);
    const [cancleTokenSource, setCancleTokenSource] = useState(null)
    const PromptRef = useRef(null);
    const authCtx = useContext(AuthContext);

    const containerRef = useRef(null);
    const targetSectionRef = useRef(null);

    const handleDeleteUserPrompt = async (index) => {
        const currUpdateArray = historyArray.filter((item, i) => (i < index));

        try {
            const res = await updateConversation(isChatSelected, { newArray: currUpdateArray });
            if (res?.status === "success") {
                setHistoryArray(currUpdateArray);

                setChats((prevChats) => {
                    return prevChats.map((item) => {
                        if (item.id === isChatSelected) {
                            return {
                                ...item, conversationArray: currUpdateArray
                            }
                        } else {
                            return item
                        }
                    })
                })
                setSummaryLoading(false);
            } else throw new Error("Fetching Summary Failed");
        } catch (e) {
            toast(
                e?.response?.data?.message
                    ? e?.response?.data?.message
                    : "An error occured. Please try again"
            );
            setSummaryLoading(false);
        }

    }

    const handleUpdateUserPrompt = async (index, value) => {

        const currUpdateArray = historyArray.map((item, i) => {
            if (index === i) {
                return value;
            } else if (index > i) {
                return item;
            } else {
                return null;
            }
        }).filter(item => item !== null);

        setHistoryArray(currUpdateArray);

        setSummaryLoading(true);

        try {
            const res = await summarizeTranscriptNew({ transcription: [...currUpdateArray], temperature: creativity, isChatSelected });
            if (res?.status === "success") {
                setHistoryArray([...currUpdateArray, res?.result?.content]);

                setChats((prevChats) => {
                    return prevChats.map((item) => {
                        if (item.id === isChatSelected) {
                            return {
                                ...item, conversationArray: [...historyArray, res?.result?.content]
                            }
                        } else {
                            return item
                        }
                    })
                })

                setSummaryLoading(false);
            } else throw new Error("Fetching Summary Failed");
        } catch (e) {

            if (e?.code && e.code === 'ERR_CANCELED') {

            } else {
                toast(
                    e?.response?.data?.message
                        ? e?.response?.data?.message
                        : "An error occured. Please try again"
                );
            }
            setSummaryLoading(false);
            setHistoryArray(historyArray);
        }

    }

    useEffect(() => {

        if (containerRef && containerRef.current) {
            containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }

    }, [summaryLoading])

    const summarizeTranscriptNew = async (request) => {
        const currCancelTokenSource = axios.CancelToken.source();
        setCancleTokenSource(currCancelTokenSource);
        const AuthHeader = getAuthHeader()

        let response = null
        if (authCtx?.user?.AI === "BASTIONGPT") {
            response = await axiosInstance.put(
                `/summarize/bastion2/`,
                request,
                {
                    ...AuthHeader,
                    cancelToken: currCancelTokenSource.token,
                }
            );
        } else {
            response = await axiosInstance.put(
                `/summarize/openai2/`,
                request,
                {
                    ...AuthHeader,
                    cancelToken: currCancelTokenSource.token,
                }
            );
        }


        return response?.data;
    };

    const handleInputChange = (e) => {
        const value = e.target.value;

        setInputValue(value);
        if (value.endsWith("/")) {
            setShowDropdown(true);
        } else {
            setShowDropdown(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();     // ⛔ Block newline
            handleSearchSummary(inputValue);        // ✅ Call your function
            // ✅ Call your function
        }
    };

    const handlePromptSelect = (prompt) => {

        setInputValue(prompt.promptText + "\n-------------------------------------------\n");

        setShowDropdown(false);
    };


    useEffect(() => {
        if (textAreaRef.current) {
            textAreaRef.current.style.height = 'auto';
            textAreaRef.current.style.height = (textAreaRef.current.scrollHeight) + 'px';
        }
    }, [inputValue]);


    useEffect(() => {
        const getPrompts = async () => {
            try {
                const res = await getAllPromptsWithoutPagination();
                if (res?.status === "success") {
                    setPrompts(res?.result ? res?.result : []);
                } else throw new Error("Fetching Prompts Failed");
            } catch (e) {
                toast(
                    e?.response?.data?.message
                        ? e?.response?.data?.message
                        : "An error occured. Please try again"
                );
            }
        };
        getPrompts();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (textAreaRef.current && receivedData?.transcription) {
            const textarea = textAreaRef.current;

            let newText = '';
            if (receivedData.prompt) {
                newText = `${receivedData.prompt.promptText}\n-------------------------------------------\n${receivedData.transcription}\n`;
                setInputValue(`${receivedData.prompt.promptText}\n-------------------------------------------\n${receivedData.transcription}\n`)
            } else {
                toast("Prompt Not Found !!!")
                newText = `${receivedData.transcription}\n`;
                setInputValue(`${receivedData.transcription}\n`)
            }

            // Update textarea value and set cursor position
            textarea.value = newText;
            textarea.setSelectionRange(newText.length, newText.length);

            // Focus the textarea
            textarea.focus();
        }
    }, [receivedData]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (PromptRef.current && PromptRef.current.contains(event.target)) {
                setEditModalVisible(false);
                console.log("AVinash")
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSearchSummary = async (inputtext) => {
        setInputValue("");
        setSummaryLoading(true);
        setHistoryArray([...historyArray, inputtext]);

        try {
            const res = await summarizeTranscriptNew({ transcription: [...historyArray, inputtext], temperature: creativity, isChatSelected });
            if (res?.status === "success") {
                setHistoryArray([...historyArray, inputtext, res?.result?.content]);
                if (isChatSelected) {
                    setChats((prevChats) => {
                        return prevChats.map((item) => {
                            if (item.id === isChatSelected) {
                                return {
                                    ...item, creativity: creativity, conversationArray: [...historyArray, inputtext, res?.result?.content]
                                }
                            } else {
                                return item
                            }
                        })
                    })
                } else {
                    setChats([{ id: res?.conversationId, title: "New Conversation", creativity: creativity, conversationArray: [...historyArray, inputtext, res?.result?.content] }, ...chats])
                    setIsChatSelected(res?.conversationId)
                    setHistoryArray([...historyArray, inputtext, res?.result?.content])
                }
                setSummaryLoading(false);
            } else throw new Error("Fetching Summary Failed");
        } catch (e) {

            if (e?.code && e.code === 'ERR_CANCELED') {
                const curr = historyArray;
                setHistoryArray(curr);
                return;
            }
            toast(
                e?.response?.data?.message
                    ? e?.response?.data?.message
                    : "An error occured. Please try again"
            );
            setSummaryLoading(false);
        }
    }

    const handleCancleRequest = () => {
        console.log("API Cancelled")
        cancleTokenSource.cancel('Request canceled by User');
        setSummaryLoading(false);
    }

    const handlePromptDelete = async (request) => {
        try {
            const res = await deletePromptByID(request);

            if (res?.status === "success") {
                setPrompts((prevPrompts) => {
                    return prevPrompts.filter((item) => item.id !== request);
                });

            } else throw new Error("Fetching Failed");
        } catch (e) {
            toast(
                e?.response?.data?.message
                    ? e?.response?.data?.message
                    : "An error occured. Please try again"
            );
        }
    }

    const handlePromptUpadte = async () => {
        const currData = {
            "id": selectedPrompt.id,
            "name": selectedPrompt.promptName,
            "prompt": selectedPrompt.promptText,
        }

        try {

            const res = await updatePrompt(currData);

            if (res?.status === "success") {
                setPrompts((prevPrompts) => {
                    const updatedPrompts = prevPrompts.map((curr) => {
                        if (curr.id === selectedPrompt.id) {
                            return selectedPrompt;
                        } else {
                            return curr;
                        }
                    })

                    return updatedPrompts;
                })
                setEditModalVisible(false);
            } else throw new Error("Prompt Update Failed");
        } catch (e) {

            setEditModalVisible(false);
            toast(
                e?.response?.data?.message
                    ? e?.response?.data?.message
                    : "An error occured. Please try again"
            );
            setLoading(false);
        }
    };

    const handleBackgroundClick = () => {
        setEditModalVisible(false);
    };

    const handleModalClick = (e) => {
        // Prevent click inside the modal from propagating to the background
        e.stopPropagation();
    };

    const handleCreatePrompt = async () => {

        if (!selectedPrompt.promptName) {
            toast("Provide Prompt Name");
            return;
        }

        if (!selectedPrompt.promptText) {
            toast("Provide Prompt Text");
            return;
        }

        const currData = {
            "name": selectedPrompt.promptName,
            "prompt": selectedPrompt.promptText,
        }

        try {
            const res = await createPrompt(currData);
            if (res?.status === "success") {
                setIsNewPrompt(false);
                setEditModalVisible(false);
                setPrompts([res.newPrompt
                    , ...prompts])
                setLoading(false);
            } else throw new Error("Prompt Update Failed");


        } catch (e) {
            setEditModalVisible(false);
            toast(
                e?.response?.data?.message
                    ? e?.response?.data?.message
                    : "An error occured. Please try again"
            );
            setLoading(false);
        }
    }


    return (
        <>
            <ToastContainer />
            <NavBar />
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "80px 1fr",
                    height: "calc(100vh - 77px)",
                }}
            >
                {
                    editModalVisible && <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                        <div className="fixed inset-0 z-10 overflow-hidden">
                            <div onClick={handleBackgroundClick} className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                                <div className="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">
                                </div>
                                <div onClick={handleModalClick} className="inline-block max-h-[400px] transform overflow-y-auto rounded-lg border border-gray-300 bg-white px-4 pt-5 pb-4 text-left align-bottom shadow-xl transition-all sm:my-8 sm:max-h-[600px] sm:w-full sm:max-w-lg sm:p-6 sm:align-middle" role="dialog">
                                    {/* <button className="closeBtn" style={{ position: 'absolute', top: 15, background: '#fff', justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 999, width: 30, height: 30 }} onClick={() => {
                                        setEditModalVisible(false)
                                        setIsNewPrompt(false);
                                    }}>
                                        <ion-icon name="close-outline" style={{ color: 'red' }} ></ion-icon>
                                    </button> */}
                                    <div className="text-sm font-bold text-black">Name</div>
                                    <input value={selectedPrompt.promptName} onChange={(e) => setSelectedPrompt({ ...selectedPrompt, promptName: e.target.value })}
                                        className="mt-2 w-full rounded-lg border border-neutral-500 px-4 py-2 text-neutral-900 shadow focus:outline-none" placeholder="A name for your prompt." />
                                    <div className="mt-6 text-sm font-bold text-black">Prompt</div>
                                    <textarea value={selectedPrompt.promptText} onChange={(e) => setSelectedPrompt({ ...selectedPrompt, promptText: e.target.value })} className="mt-2 w-full rounded-lg border border-neutral-500 px-4 py-2 text-neutral-900 shadow focus:outline-none" placeholder="Enter your prompt here." rows="10" style={{ resize: 'none' }}></textarea>
                                    <button type="button" onClick={() => {
                                        if (isNewPrompt) {
                                            handleCreatePrompt();
                                        } else {
                                            handlePromptUpadte();
                                        }
                                    }
                                    } className="w-full px-4 py-2 mt-6 border rounded-lg shadow border-neutral-500 text-neutral-900 hover:bg-neutral-100 focus:outline-none">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <SideBar />
                <div className="flex h-full w-full sm:pt-0 overflow-y-auto">
                    <LeftPanel summaryLoading={summaryLoading} setHistoryArray={setHistoryArray} setIsChatSelected={setIsChatSelected} isChatSelected={isChatSelected} chats={chats} setChats={setChats}
                        creativity={creativity} setCreativity={setCreativity} />

                    <div className="mainContainer flex flex-1">
                        <div className="relative flex-1 overflow-hidden bg-white">
                            <div className="max-h-full overflow-x-hidden" ref={targetSectionRef}>

                                {
                                    historyArray.length === 0 ? <div className="mx-auto flex flex-col space-y-5 md:space-y-10 px-3 pt-5 md:pt-12 sm:max-w-[600px]">
                                        <div className="text-center text-3xl font-semibold text-gray-800">
                                            <span className="inline-flex items-center">
                                                <img alt="Logo" loading="lazy" width="100" height="100" decoding="async" data-nimg="1"
                                                    src={AIimage}
                                                    style={{ marginRight: "10px" }}
                                                />

                                            </span>
                                        </div>
                                        {/* <div className="flex h-full flex-col space-y-4 rounded-lg border border-neutral-200 p-4 setDivScroll">
                                            <div className="flex flex-col"></div>
                                            <div className="flex h- justify-center items-center flex-col flex-1 space-y-4 rounded-lg p-4 text-center">Warning: BastionGPT may produce inaccurate information about people, places, or facts.
                                            </div>
                                            <div className="flex flex-col"></div><div className="flex flex-col">
                                                <label className="mb-2 text-left text-neutral-700">
                                                    Creativity
                                                </label>
                                                <span className="text-[12px] text-black/50/50 text-sm">
                                                    Higher values will give more creative answers, while lower values will provide more concise and straightforward answers.</span>
                                                <span className="mt-2 mb-1 text-center text-neutral-900">{creativity}</span>
                                                <input
                                                    className="cursor-pointer"
                                                    type="range"
                                                    min="0"
                                                    max="1"
                                                    step="0.1"
                                                    value={creativity}
                                                    onChange={(e) => {
                                                        const newValue = parseFloat(e.target.value);
                                                        setCreativity(newValue)
                                                    }}
                                                />
                                                <ul className="w mt-2 pb-4 flex justify-between px-[24px] text-neutral-900">
                                                    <li className="flex justify-center">
                                                        <span>Precise</span>
                                                    </li>
                                                    <li className="flex justify-center">
                                                        <span>Neutral</span>
                                                    </li>
                                                    <li className="flex justify-center">
                                                        <span>Creative</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div> */}
                                    </div> : null
                                }


                                {
                                    <>
                                        {
                                            historyArray.length !== 0 ? <div className="sticky top-0 z-10 flex justify-center border border-b-neutral-300 bg-neutral-100 py-2 text-sm text-neutral-500">
                                                Environment: Production
                                                {/* | Creativity : {creativity} */}
                                            </div> : null
                                        }

                                        {
                                            historyArray.map((item, index) => {
                                                if (index % 2 == 0) {
                                                    return <div key={index} style={{ paddingBottom: (index === historyArray.length - 1) ? "200px" : "0px" }} >
                                                        <UserPrompt textValue={item} index={index} handleDeleteUserPrompt={handleDeleteUserPrompt} handleUpdateUserPrompt={handleUpdateUserPrompt} />
                                                    </div>

                                                } else {
                                                    return <div key={index} ref={(index === historyArray.length - 1) ? containerRef : null} className="group md:px-4 border-b border-black/10 bg-gray-50 text-gray-800" style={{ overflowWrap: "anywhere", paddingBottom: (index === historyArray.length - 1) ? "200px" : "0px" }}>
                                                        <div className="relative m-auto flex p-4 text-base md:max-w-2xl md:gap-6 md:py-6 lg:max-w-2xl lg:px-0 xl:max-w-3xl">
                                                            <div className="min-w-[40px] text-right font-bold">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-robot">
                                                                    <path d="M6 4m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"></path>
                                                                    <path d="M12 2v2"></path>
                                                                    <path d="M9 12v9"></path>
                                                                    <path d="M15 12v9"></path>
                                                                    <path d="M5 16l4 -2"></path>
                                                                    <path d="M15 14l4 2"></path>
                                                                    <path d="M9 18h6"></path>
                                                                    <path d="M10 8v.01"></path>
                                                                    <path d="M14 8v.01"></path>
                                                                </svg>
                                                            </div>
                                                            <div className="prose mt-[-2px] w-full">
                                                                <div className="flex flex-row">
                                                                    <div className="prose flex-1" dangerouslySetInnerHTML={{
                                                                        __html: formatText(item),
                                                                    }}>

                                                                    </div>
                                                                    <div className="md:-mr-0 ml-1 md:ml-0 flex flex-col md:flex-row gap-4 md:gap-1 items-center md:items-start justify-end md:justify-start">
                                                                        <button onClick={() => {
                                                                            setIsCopied(true);
                                                                            navigator.clipboard.writeText(item).catch((err) => {
                                                                                toast("Error while Copying")
                                                                            }).finally(() => {
                                                                                setTimeout(() => {
                                                                                    setIsCopied(false);
                                                                                }, 2000)
                                                                            })
                                                                        }} className="invisible group-hover:visible focus:visible text-gray-500 hover:text-gray-700">
                                                                            {
                                                                                isCopied ? <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="text-green-500"><path d="M5 12l5 5l10 -10"></path></svg> :
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-copy">
                                                                                        <path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z"></path>
                                                                                        <path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1"></path>
                                                                                    </svg>
                                                                            }
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }


                                            })
                                        }

                                    </>
                                }


                            </div>
                            <div className="absolute bottom-0 left-0 w-full border-transparent bg-gradient-to-b from-transparent via-white to-white pt-6 md:pt-2">
                                <div className="stretch mx-2 mt-4 flex flex-row gap-3 last:mb-2 md:mx-5 md:mt-[52px] md:last:mb-4 lg:mx-auto lg:max-w-4xl">
                                    {
                                        summaryLoading ? <button onClick={handleCancleRequest} className="absolute top-0 left-0 right-0 mx-auto mb-3 flex w-fit items-center gap-3 rounded border border-neutral-200 bg-white py-2 px-4 text-black hover:opacity-50 md:mb-0 md:mt-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-player-stop">
                                                <path d="M5 5m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"></path>
                                            </svg>
                                            Stop Generating
                                        </button> : null
                                    }
                                    <div className="relative rounded p-2 mx-2 sm:mx-4 flex w-full flex-grow flex-row flex-wrap gap-2 bg-white shadow-[0_0_10px_rgba(0,0,0,0.10)]">
                                        <div className="grow flex items-center">
                                            <textarea value={inputValue} ref={textAreaRef} onChange={handleInputChange}
                                                className="w-full resize-none border border-black/100  rounded-md bg-transparent p-0 pr-2 pl-2 text-black md:py-3 md:pl-2"
                                                placeholder="Type a message or type &quot;/&quot; to select a prompt..."
                                                rows="1"
                                                onKeyDown={handleKeyDown}
                                                style={{
                                                    resize: 'none', maxHeight: '400px', overflowY: 'auto', // Use 'auto' to add a scroll bar when needed
                                                }}
                                            >
                                            </textarea>
                                        </div>

                                        <div className="flex items-center">
                                            <button disabled={summaryLoading} onClick={() => {
                                                handleSearchSummary(inputValue);
                                            }} className="p-1 rounded-sm text-neutral-800 opacity-60 hover:bg-neutral-200 hover:text-neutral-900">
                                                {
                                                    summaryLoading ? <div className="h-4 w-4 animate-spin rounded-full border-t-2 border-neutral-800 opacity-100"></div>
                                                        : <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-send">
                                                            <path d="M10 14l11 -11"></path>
                                                            <path d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5"></path>
                                                        </svg>
                                                }
                                            </button>
                                        </div>
                                        {
                                            showDropdown ? <div className="absolute bottom-20 w-full right-0 overflow-x-scroll max-h-52 z-10 rounded border border-black/10 bg-white shadow-[0_0_10px_rgba(0,0,0,0.10)]">

                                                {
                                                    prompts.map(prompt => {
                                                        return <li key={prompt.id} onClick={() => handlePromptSelect(prompt)} className="hover:bg-[#7accff] hover:text-white cursor-pointer px-3 py-2 text-sm text-black w-full">
                                                            {prompt.promptName}
                                                        </li>
                                                    })
                                                }

                                            </div> : null
                                        }
                                    </div>
                                </div>
                                <div className="px-3 pt-2 pb-3 text-center text-[12px] text-black/50/50 md:px-4 md:pt-1 md:pb-3">Data entered into this chat is secure and protected</div>
                            </div>
                        </div>
                    </div>

                    {
                        rightPanel ? <div>
                            <div className="fixed top-0 right-0 z-40 flex h-full w-[260px] flex-none flex-col space-y-2 bg-[#f0f0f0] p-2 text-[14px] text-black transition-all sm:relative sm:top-0">
                                <div className="flex items-center gap-2">
                                    <button onClick={() => {
                                        setEditModalVisible(true);
                                        setSelectedPrompt({
                                            "name": "",
                                            "prompt": ""
                                        })
                                        setIsNewPrompt(true);
                                    }} className="text-sidebar flex flex-1 cursor-pointer select-none items-center gap-3 rounded-md border border-white/20 p-3 text-black transition-colors duration-200 hover:bg-gray-500/10">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-plus">
                                            <path d="M12 5l0 14"></path>
                                            <path d="M5 12l14 0"></path>
                                        </svg>
                                        New prompt
                                    </button>
                                    {/* <button className="flex flex-shrink-0 cursor-pointer items-center gap-3 rounded-md border border-white/20 p-3 text-sm text-black transition-colors duration-200 hover:bg-gray-500/10">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-folder-plus">
                                            <path d="M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3.5"></path><path d="M16 19h6"></path>
                                            <path d="M19 16v6"></path>
                                        </svg>
                                    </button> */}
                                    <button onClick={() => setRightPanel(false)} className="right-[270px] z-50 rounded-md border border-white/20 sm:top-0.5 sm:right-[270px] p-2 sm:text-neutral-700 transition-colors duration-200 hover:bg-gray-500/10">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-arrow-bar-right">
                                            <path d="M20 12l-10 0"></path>
                                            <path d="M20 12l-4 4"></path>
                                            <path d="M20 12l-4 -4"></path><path d="M4 4l0 16"></path>
                                        </svg>
                                    </button>
                                    <div onClick={() => setRightPanel(false)} className="top-0 left-0 z-10 h-full w-full bg-black opacity-70 hidden">
                                    </div>
                                </div>
                                <div className="relative flex items-center">
                                    <input
                                        value={promptSearch}
                                        onChange={(e) => setPromptSearch(e.target.value)}
                                        className="w-full flex-1 rounded-md border border-neutral-600 bg-[#2343541] px-4 py-3 pr-10 text-[14px] leading-3 text-black" type="text" placeholder="Search..." />
                                </div>
                                {
                                    prompts.length === 0 ? <div className="flex-grow overflow-auto">
                                        <div className="mt-8 select-none text-center text-black opacity-50">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="mx-auto mb-3" >
                                                <path d="M12 5h9"></path>
                                                <path d="M3 10h7"></path>
                                                <path d="M18 10h1"></path>
                                                <path d="M5 15h5"></path>
                                                <path d="M14 15h1m4 0h2"></path>
                                                <path d="M3 20h9m4 0h3"></path>
                                                <path d="M3 3l18 18"></path>
                                            </svg>
                                            <span className="text-[14px] leading-normal">No data.</span>
                                        </div>
                                    </div> : <div className='flex-grow overflow-auto'>
                                        <div className='pt-2'>
                                            {
                                                prompts.filter(prompt => {
                                                    if (prompt?.promptName.includes(promptSearch)) {
                                                        return prompt;
                                                    }
                                                }).map((prompt) => {
                                                    return <PromptBar
                                                        prompt={prompt}
                                                        setEditModalVisible={setEditModalVisible}
                                                        setSelectedPrompt={(prompt) => {
                                                            setInputValue(prompt.promptText + "\n-------------------------------------------\n");

                                                            if (textAreaRef.current) {
                                                                const textArea = textAreaRef.current;
                                                                textArea.focus();
                                                                console.log(textArea.scrollHeight);
                                                                // textArea.scrollTop = textArea.scrollHeight;
                                                            }
                                                        }}
                                                        handlePromptDelete={handlePromptDelete}
                                                        key={prompt.id} />
                                                })
                                            }
                                        </div>
                                    </div>
                                }

                            </div>
                        </div> :
                            <button onClick={() => {
                                setRightPanel(true)
                            }} className="right-2 z-50 border rounded-md border-white/20 text-black sm:top-0.5 sm:right-2 p-2 sm:text-neutral-700 transition-colors duration-200 hover:bg-gray-500/10"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="tabler-icon tabler-icon-arrow-bar-left">
                                    <path d="M4 12l10 0"></path>
                                    <path d="M4 12l4 4"></path>
                                    <path d="M4 12l4 -4"></path>
                                    <path d="M20 4l0 16"></path>
                                </svg>
                            </button>
                    }

                </div>
            </div >

        </>
    )
}

export default BastionGPTScreen